import {
  ACCOUNTS_INSIGHTS_AGE,
  ACCOUNTS_INSIGHTS_LOADING,
  ACCOUNTS_INSIGHTS_NATIONALITY,
  ACCOUNTS_INSIGHTS_SIZE,
  ACCOUNTS_INSIGHTS_TOP,
  ACCOUNTS_INSIGHTS_TYPE,
  CLEAR_ACCOUNTS_INSIGHTS,
  GET_ACCOUNTS_INSIGHTS_CONTACTS,
} from './accountsInsightsTypes'

const initState = {
  contacts: { data: [], query: { first: 0, limit: 5, totalRecords: 0 } },
  data: {
    nationality: {},
    companyType: {},
    companySize: {},
    // accounts age
    companyAge: {},
    topTenAccounts: {},
  },
  loading: false,
}

const accountsInsightsReducer = (state = initState, action) => {
  switch (action.type) {
    case ACCOUNTS_INSIGHTS_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case ACCOUNTS_INSIGHTS_NATIONALITY:
      return {
        ...state,
        data: {
          ...state.data,
          nationality: action.payload,
        },
      }
    case ACCOUNTS_INSIGHTS_TYPE:
      return {
        ...state,
        data: {
          ...state.data,
          companyType: action.payload,
        },
      }
    case ACCOUNTS_INSIGHTS_SIZE:
      return {
        ...state,
        data: {
          ...state.data,
          companySize: action.payload,
        },
      }
    case ACCOUNTS_INSIGHTS_AGE:
      return {
        ...state,
        data: {
          ...state.data,
          companyAge: action.payload,
        },
      }
    case ACCOUNTS_INSIGHTS_TOP:
      return {
        ...state,
        data: {
          ...state.data,
          topTenAccounts: action.payload,
        },
      }
    case GET_ACCOUNTS_INSIGHTS_CONTACTS:
      return {
        ...state,
        contacts: action.payload,
      }
    case CLEAR_ACCOUNTS_INSIGHTS:
      return {
        initState,
      }
    default:
      return state
  }
}

export default accountsInsightsReducer
